/** Largest money amount the API accepts (mirrors _MAX_MONEY in apps/api/app/api/v1/crm.py). */
export const MAX_AMOUNT = 99_999_999_999.99;

export type AmountResult = { value: number | null; error: null } | { value: null; error: string };

/**
 * Parse a money field the user typed. Blank means "no amount". Anything that is not a plain
 * number is an error to show, never silently dropped (parseFloat("abc") -> NaN -> saved as blank,
 * parseFloat("12abc") -> 12).
 */
export function parseAmount(raw: string, label = "Amount", options?: { allowZero?: boolean }): AmountResult {
  const text = raw.trim().replace(/[,\s]/g, "");
  if (!text) return { value: null, error: null };
  if (!/^-?\d+(\.\d+)?$/.test(text)) return { value: null, error: `${label} must be a number, for example 1500.00.` };
  const value = Number(text);
  if (value < 0) return { value: null, error: `${label} cannot be negative.` };
  if (value === 0 && options?.allowZero === false) return { value: null, error: `${label} must be greater than zero.` };
  if (value > MAX_AMOUNT) return { value: null, error: `${label} is too large.` };
  return { value, error: null };
}
